import { get, create, update, remove } from "@/utill/getData";

export function getCommonCodeList(searchQuery) {
  if (searchQuery) {
    return get(`/system/commonCode?${searchQuery}`);
  } else {
    return get(`/system/commonCode`);
  }
}

export async function getCommonCodeListV2(searchQuery) {
  const response = await get(`/system/commonCode?${searchQuery}`);
  return response.data.response.codeList;
}

export function getMainCodeList() {
  return get("/system/classificationCode");
}

export function addCommCode(param) {
  return create("/system/commonCode", param);
}

export function updateCommCode(param) {
  return update(`/system/commonCode/${param.codeId}`, param);
}

export function removeCommCode(codeId) {
  return remove(`/system/commonCode/${codeId}`);
}
